import { SESSION_COUNTDOWN_MS } from 'config'
import { useCountdown } from 'shared/hooks/use-countdown'
import { useSessionExpiresAt } from '../SessionExpiresAtContext'
import { getSessionGracePeriodEnd } from '../utils/sessionExpiryHold'

// Seconds left until the session expires, or null before the countdown starts
export const useSessionCountdown = () => {
  const sessionExpiresAt = useSessionExpiresAt()

  return useCountdown(
    sessionExpiresAt,
    sessionExpiresAt && sessionExpiresAt - SESSION_COUNTDOWN_MS
  )
}

// Seconds left until an expired session is ended in every tab, though its
// expiry is held, see useIsSessionExpiryPaused. Null before it expires.
export const useSessionEndCountdown = () => {
  const sessionExpiresAt = useSessionExpiresAt()

  return useCountdown(
    getSessionGracePeriodEnd(sessionExpiresAt),
    sessionExpiresAt
  )
}
